import * as React from 'react';
import { IconProps } from '../types';

export const ConanIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 200, ...props }, forwardedRef) => (
    <svg 
        width={size} 
        height={size} 
        viewBox="-7.5 0 256 256" 
        {...props} 
        ref={forwardedRef}><path fill="#AFD4E5" d="M118.874 0 0 56.984l118.874 72.557 121.404-66.093z"/><path fill="#69C" d="M0 170.587 118.874 256V129.54L0 56.986z"/><path fill="#7DA7D3" d="M118.874 129.54V256l121.404-79.02V63.45z"/><path fill="#369" d="m184.556 213.249 2.831-1.843-2.4-117.857-2.143 1.166z"/><path d="m161.91 77.054 30.502-16.468s-45.97-50.157-100.11-21.033C66.83 53.255 59.24 67.026 70.516 81.73c18.662 24.338 41.17 21.606 41.17 21.606L141.04 89.05s-31.876 4.205-45.356-6.959c-11.057-9.159-6.414-20.817 8.845-31.44 13.388-9.321 40.036-5.565 49.479 1.564 9.442 7.127 13.11 17.095 7.903 24.839" fill="#69C"/></svg>
  )
);

ConanIcon.displayName = 'ConanIcon';